<ng-container *ngIf="control">
  <mat-form-field appearance="outline">
    <mat-label *ngIf="inputData['label']">{{ inputData.label }}</mat-label>
    <mat-select
      (selectionChange)="onValueChange($event, selectOptions)"
      [formControl]="control">
      <mat-option value="">Please Select</mat-option>
      @for (data of selectOptions; track $index) {
        <mat-option [value]="data[bindValue]">
          {{ data[bindLabel] | titlecase }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-container>
